import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";
import MediaCard from "@/components/feature/MediaCard";
import SectionHeading from "@/components/base/SectionHeading";

const featured = [...mediaList].sort((a, b) => b.rating - a.rating).slice(0, 8);

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <SectionHeading
        eyebrow="精选推荐"
        title="本季高分影视推荐"
        description="由编辑根据口碑与热度精选，覆盖电影与电视剧，帮你快速锁定值得一看的作品。"
        action={
          <Link
            to="/category/popular"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部推荐
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {featured.map((item, i) => (
          <MediaCard key={item.id} item={item} index={i} />
        ))}
      </div>
    </section>
  );
}